"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalileanMiningRebalanced = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var GalileanMiningRebalanced = (function (_super) {
    __extends(GalileanMiningRebalanced, _super);
    function GalileanMiningRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.GALILEAN_MINING_REBALANCED,
            tags: [Tags_1.Tags.JOVIAN],
            metadata: {
                cardNumber: 'P13',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.titanium(2);
                    }).br;
                }),
                description: 'Increase your titanium production 2 steps.',
            },
        }) || this;
    }
    GalileanMiningRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.TITANIUM, 2);
        return undefined;
    };
    return GalileanMiningRebalanced;
}(PreludeCard_1.PreludeCard));
exports.GalileanMiningRebalanced = GalileanMiningRebalanced;
//# sourceMappingURL=GalileanMiningRebalanced.js.map